//#region : Imports

import
{
    NgModule
}
from '@angular/core';

import
{
    Routes,
    RouterModule
}
from '@angular/router';

import
{
    AnalyticsComponent
}
from './components/analytics/analytics.component';

import
{
    MapViewComponent
}
from './components/mapview/mapview.component';

import
{
    AdminComponent
}
from './components/admin/admin.component';

import
{
    LoginComponent
}
from './components/login/login.component';
import
{
    FaqComponent
}
from './pages/faq/faq.component';

//#endregion

const routes: Routes = [
{
    path: '',
    component: LoginComponent
},
{
    path: 'analytics',
    component: AnalyticsComponent
},
{
    path: 'map',
    component: MapViewComponent
},
{
    path: 'admin',
    component: AdminComponent
},
{
    path: 'faq',
    component: FaqComponent
},
{
    path: 'resetpass',
    component: LoginComponent
}];

@NgModule(
{
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule]
})

export class AppRoutingModule
{}